import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonSize} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

import {FILTER_OPERATOR_TYPE_TO_READABLE} from './SQLTemplateFormConstants';
import {ColumnFilterType} from './SQLTemplateFormTypes';

export const ORDERED_COLUMN_FILTER_TYPES = [ColumnFilterType.IS_ONE_OF, ColumnFilterType.IS_NONE_OF];

export interface SQLFilterOperatorSelectorProps {
  buttonSize?: ButtonSize;
  columnFilterTypeOptions?: Array<ColumnFilterType>;
  selectedType: ColumnFilterType;
  onUpdateOperator: (filterType: ColumnFilterType) => void;
  disabled?: boolean;
}

export default function SQLFilterOperatorSelector(props: SQLFilterOperatorSelectorProps): JSX.Element {
  const columnFilterTypeOptions = props.columnFilterTypeOptions ?? ORDERED_COLUMN_FILTER_TYPES;

  return (
    <SelectDropdown
      buttonSize={props.buttonSize ?? ButtonSize.SMALL}
      className={css(styles.selectButton)}
      disabled={props.disabled}
      displayName={FILTER_OPERATOR_TYPE_TO_READABLE[props.selectedType]}
      menu={
        <Menu height={MenuHeight.MEDIUM} width={MenuWidth.LARGE}>
          {columnFilterTypeOptions.map((filterType, idx) => (
            <Option
              key={idx}
              value={filterType}
              onSelect={() => {
                props.onUpdateOperator(filterType);
              }}
            >
              {FILTER_OPERATOR_TYPE_TO_READABLE[filterType]}
            </Option>
          ))}
        </Menu>
      }
    />
  );
}

const styles = StyleSheet.create({
  selectButton: {
    whiteSpace: 'nowrap',
  },
});
